import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTableModule } from '@angular/material/table';
import { RouterModule, Routes } from '@angular/router';
import { DocumentTemplatesComponent } from './document-templates.component';
import { EditTemplateModalComponent } from './edit-template-modal/edit-template-modal.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { QuillModule } from 'ngx-quill';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonToggleModule} from '@angular/material/button-toggle';
import { MatChipsModule } from '@angular/material/chips';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCardModule } from '@angular/material/card';
import { CdkMenuModule } from '@angular/cdk/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { EditorComponent } from '@tinymce/tinymce-angular';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ConfigTemplateComponent } from './config-template/config-template.component';
import { EditUsedTemplateComponent } from './edit-used-template/edit-used-template.component';
import { MatSelectModule } from '@angular/material/select';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path:'',
        component: DocumentTemplatesComponent,
        data: {
          urls: [
            {title: 'Plantillas', url: 'setting/document-templates'}
          ]
        }
      }
    ]
  }
];

@NgModule({
  declarations: [
    DocumentTemplatesComponent,
    EditTemplateModalComponent,
    ConfigTemplateComponent,
    EditUsedTemplateComponent,
    //EditorComponent 
  ],
  imports: [
    RouterModule.forChild(routes),
    CommonModule,
    CdkMenuModule,
    MatTableModule,
    MatCardModule,
    MatDialogModule,
    MatButtonModule,
    MatPaginatorModule,
    MatSortModule,
    MatChipsModule,
    MatButtonToggleModule,
    MatInputModule,
    MatFormFieldModule,
    FormsModule,
    MatIconModule,
    MatTooltipModule,
    EditorComponent,
    MatProgressSpinnerModule,
    ReactiveFormsModule,
    MatSelectModule,
    QuillModule.forRoot()
  ],
  exports: [RouterModule]

})
export class DocumentTemplateModule { }
